function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Artboard",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "add_folder/24\\u044524"
}, React.createElement("path", {
  d: "M16.2928934,12.2928932 L16.2097048,12.3871006 C15.9046799,12.7793918 15.9324095,13.3466228 16.2928934,13.7071068 C16.6533774,14.0675907 17.2206085,14.0953203 17.6128997,13.7902954 L17.707107,13.7071068 L22.707107,8.70710678 L22.7902956,8.61289944 C23.0699018,8.25329917 23.0699018,7.74670083 22.7902956,7.38710056 L22.707107,7.29289322 L17.707107,2.29289322 L17.6128997,2.20970461 C17.2532994,1.93009846 16.7467011,1.93009846 16.3871008,2.20970461 L16.2928934,2.29289322 L16.2097048,2.38710056 C15.9300987,2.74670083 15.9300987,3.25329917 16.2097048,3.61289944 L16.2928934,3.70710678 L19.5840002,6.999 L15.0016805,7 C6.79019874,7 1.00523942,13.1145711 1,20.9993356 C0.999633484,21.5516202 1.44705115,21.9996328 1.99933578,22 C2.55162041,22.0003667 2.99963304,21.5529491 3,21.0006644 C3.00445198,14.3003484 7.77001458,9.16024725 14.6763864,9.00367616 L15.0016805,9 L19.5860002,8.999 L16.2928934,12.2928932 Z",
  id: "Path"
})));

var SvgIRedo = function SvgIRedo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIRedo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/i-redo.a9e0e187.svg";
export { ForwardRef as ReactComponent };